export default "__VITE_ASSET__CVM7H4nr__"